import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ModuleauthService } from 'app/services/moduleauth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModulechildAuthGuardService implements CanActivateChild{

  constructor(private _authService: ModuleauthService, private _router: Router) { }
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let url: string = state.url;
    return this.checkUserModuleChild(childRoute, url);
  }

  checkUserModuleChild(route: ActivatedRouteSnapshot, url: any): boolean {
    console.log(route,url)
    if (this._authService.isAuthenticatedmodule()) {
      const userRole = this._authService.getModule();
      console.log(userRole)
      if (userRole[0].customer['add'] === false) {
        console.log(userRole[0].customer['add'])
        return false
      }
      return true
    }
    this._router.navigate(['/customers']);
    return false;
  }
}
